var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFrFocus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_FR_focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_FR_focus",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7AC82",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#D9E8F6",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(142.000000, 36.500000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#003A5D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.38775373,
    y: 6.38775373,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 3.19387686,
    y: 3.19387686,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 67.0714141,
    height: 83.8392676
  })), /*#__PURE__*/React.createElement("text", {
    id: "$",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#003A5D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 167.30193,
    y: 63.5
  }, "$")), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(149.000000, 69.500000)",
    fill: "#B7AC82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 12,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 24,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 36,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 29,
    y: 0,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 29,
    y: 12,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 29,
    y: 24,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 29,
    y: 36,
    width: 23,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#003A5D",
    x: 113.5,
    y: 77.178569,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#003A5D",
    fillRule: "nonzero",
    transform: "translate(136.458653, 80.678569) rotate(90.000000) translate(-136.458653, -80.678569) ",
    points: "136.458653 69.178569 147.637222 92.178569 136.458653 88.178569 125.280084 92.178569"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 28.5816306,
    y: 60.543361,
    width: 75.8545755,
    height: 55.0943759
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5974396,58.1761346 L20.5974396,62.9011936 C20.5790907,63.3482533 21.0668273,63.7219206 21.6887031,63.7372378 L111.329134,63.7372378 C111.951009,63.7219206 112.438746,63.3482533 112.420397,62.9011936 L112.420397,58.1761346 C112.431464,57.732697 111.945796,57.3647946 111.329134,57.3494841 L21.6821685,57.3494841 C21.0680846,57.3672856 20.5862826,57.734457 20.5974396,58.1761346 L20.5974396,58.1761346 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.194263,118.41164 L22.194263,114.460772 C22.1889396,114.352621 22.2388349,114.247302 22.3327876,114.168372 C22.4267397,114.089444 22.5569091,114.043492 22.694176,114.040798 L110.323661,114.040798 C110.460928,114.043492 110.591097,114.089444 110.685049,114.168372 C110.779002,114.247302 110.828897,114.352621 110.823573,114.460772 L110.823573,118.41164 C110.828897,118.519791 110.779002,118.62511 110.685049,118.70404 C110.591097,118.782969 110.460928,118.82892 110.323661,118.831614 L22.694176,118.831614 C22.5569091,118.82892 22.4267397,118.782969 22.3327876,118.70404 C22.2388349,118.62511 22.1889396,118.519791 22.194263,118.41164 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1407286,71.9551906 L50.1407286,67.4884731 C50.1372556,67.3447997 50.1808659,67.2053382 50.261956,67.1007997 C50.3430455,66.9962612 50.4549654,66.9352188 50.5730683,66.9311147 L58.4906919,66.9311147 C58.6087948,66.9352188 58.7207147,66.9962612 58.8018042,67.1007997 C58.8828943,67.2053382 58.9265045,67.3447997 58.9230316,67.4884731 L58.9230316,71.9551906 C58.9282661,72.1001965 58.8854432,72.2416914 58.8041653,72.347948 C58.7228874,72.4542045 58.6099551,72.5163318 58.4906919,72.5203992 L50.5730683,72.5203992 C50.4538051,72.5163318 50.3408728,72.4542045 50.2595949,72.347948 C50.178317,72.2416914 50.1354941,72.1001965 50.1407286,71.9551906 L50.1407286,71.9551906 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9851723,71.9551906 L26.9851723,67.4884731 C26.9816994,67.3447997 27.0253092,67.2053382 27.1063988,67.1007997 C27.1874878,66.9962612 27.2994069,66.9352188 27.4175089,66.9311147 L35.3415305,66.9311147 C35.5849257,66.943868 35.7747014,67.1922294 35.7674144,67.4884731 L35.7674144,71.9551906 C35.7726618,72.098883 35.7307147,72.2392141 35.6508229,72.3452421 C35.5709309,72.45127 35.4596552,72.5142873 35.3415305,72.5203992 L27.3981506,72.5203992 C27.1572746,72.4994218 26.9740561,72.2486662 26.9851723,71.9551906 L26.9851723,71.9551906 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0001661,127.8118 L19.0001661,122.626935 C18.9927717,122.304987 19.2332192,122.036763 19.5393273,122.025491 L113.484886,122.025491 C113.631399,122.030894 113.769859,122.097321 113.869758,122.210135 C113.969657,122.322951 114.022798,122.472896 114.017472,122.626935 L114.017472,127.8118 C114.022798,127.965839 113.969657,128.115784 113.869758,128.2286 C113.769859,128.341414 113.631399,128.407841 113.484886,128.413244 L19.5393273,128.413244 C19.2332192,128.401972 18.9927717,128.133748 19.0001661,127.8118 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2504223,71.9551906 L97.2504223,67.4884731 C97.2431351,67.1922294 97.432912,66.943868 97.6763087,66.9311147 L105.600376,66.9311147 C105.718479,66.9352188 105.830399,66.9962612 105.911488,67.1007997 C105.992578,67.2053382 106.036188,67.3447997 106.032715,67.4884731 L106.032715,71.9551906 C106.03795,72.1001965 105.995127,72.2416914 105.913849,72.347948 C105.832571,72.4542045 105.719639,72.5163318 105.600376,72.5203992 L97.6763087,72.5203992 C97.5581833,72.5142873 97.446907,72.45127 97.3670145,72.3452421 C97.2871221,72.2392141 97.2451749,72.098883 97.2504223,71.9551906 L97.2504223,71.9551906 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2963358,71.9551906 L73.2963358,67.4884731 C73.2928629,67.3447997 73.3364731,67.2053382 73.4175631,67.1007997 C73.4986525,66.9962612 73.6105722,66.9352188 73.7286751,66.9311147 L81.6527425,66.9311147 C81.7702955,66.9351807 81.8815867,66.9964808 81.9616547,67.1012657 C82.0417226,67.2060506 82.0838647,67.3455495 82.0786289,67.4884731 L82.0786289,71.9551906 C82.0838763,72.098883 82.0419291,72.2392141 81.9620366,72.3452421 C81.8821442,72.45127 81.7708679,72.5142873 81.6527425,72.5203992 L73.7286751,72.5203992 C73.609412,72.5163318 73.4964798,72.4542045 73.415202,72.347948 C73.3339242,72.2416914 73.2911013,72.1001965 73.2963358,71.9551906 L73.2963358,71.9551906 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5816306,110.598752 L28.5816306,75.1639767 C28.7199753,74.9448545 28.8660432,74.8696428 29.0105905,74.943101 L33.7419552,74.943101 C33.8865024,74.8696428 34.0325704,74.9448545 34.1709151,75.1639767 L34.1709151,110.598752 C34.0325704,110.817874 33.8865024,110.893085 33.7419552,110.819628 L29.0105905,110.819628 C28.8660432,110.893085 28.7199753,110.817874 28.5816306,110.598752 L28.5816306,110.598752 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7372378,110.598752 L51.7372378,75.1639767 C51.8754243,74.9448545 52.021325,74.8696428 52.165707,74.943101 L56.8980532,74.943101 C57.0424352,74.8696428 57.1883359,74.9448545 57.3265224,75.1639767 L57.3265224,110.598752 C57.1883359,110.817874 57.0424352,110.893085 56.8980532,110.819628 L52.165707,110.819628 C52.021325,110.893085 51.8754243,110.817874 51.7372378,110.598752 L51.7372378,110.598752 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8469216,110.597566 L98.8469216,75.1651627 C98.9832889,74.9477147 99.1273639,74.8724965 99.2699641,74.9443018 L104.013164,74.9443018 C104.155765,74.8686854 104.300001,74.9439882 104.436206,75.1651627 L104.436206,110.597566 C104.300001,110.818739 104.155765,110.894043 104.013164,110.818427 L99.2507346,110.818427 C99.114487,110.877255 98.9772222,110.802181 98.8469216,110.597566 L98.8469216,110.597566 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8928451,110.598752 L74.8928451,75.1639767 C75.0311898,74.9448545 75.1772578,74.8696428 75.321805,74.943101 L80.0531697,74.943101 C80.1977169,74.8696428 80.3437849,74.9448545 80.4821296,75.1639767 L80.4821296,110.598752 C80.3437849,110.817874 80.1977169,110.893085 80.0531697,110.819628 L75.321805,110.819628 C75.1772578,110.893085 75.0311898,110.817874 74.8928451,110.598752 L74.8928451,110.598752 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3394144,31.0489101 L29.5172178,53.6102466 C29.4054522,53.684063 29.3555285,53.8129107 29.3917685,53.9340195 C29.4280084,54.0551284 29.5428739,54.1433107 29.6804078,54.1556073 L103.324801,54.1556073 C103.466984,54.1502745 103.588975,54.0618982 103.626292,53.9371908 C103.663608,53.8124832 103.607648,53.6801942 103.487991,53.6102466 L66.6657945,31.0489101 C66.5688511,30.9836966 66.4363578,30.9836966 66.3394144,31.0489101 Z M67.1096713,47.5994228 L67.1096713,48.9628246 L65.7454027,48.9628246 L65.7454027,47.6824125 C64.9193244,47.6569586 64.1116977,47.4537951 63.3889388,47.0896291 L63.8001777,45.5128252 C64.4997146,45.8913376 65.2967216,46.0957944 66.1109484,46.1056086 C66.9007881,46.1056086 67.4164686,45.8092169 67.4164686,45.269784 C67.4164686,44.7303511 66.9725917,44.4398873 65.9412308,44.0842172 C64.4594654,43.5981348 63.4411596,42.8986504 63.4411596,41.6241661 C63.4637758,40.4122214 64.4662763,39.4006778 65.7910959,39.2530324 L65.7910959,37.9904038 L67.148837,37.9904038 L67.148837,39.1759706 C67.8488751,39.1885476 68.5373712,39.3403038 69.1658656,39.6205581 L68.7611544,41.1380837 C68.1450305,40.8432651 67.4601082,40.6867511 66.7637085,40.6816405 C65.8628996,40.6816405 65.5691575,41.0610218 65.5691575,41.4344754 C65.5691575,41.807929 66.0522,42.1635989 67.2336958,42.590403 C68.8851788,43.1831864 69.5509941,43.9004543 69.5509941,45.1097325 C69.5504895,46.3818584 68.5010778,47.4520607 67.1096713,47.5994228 Z",
    id: "Shape",
    fill: "#003A5D",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrFocus);
export default __webpack_public_path__ + "static/media/Icon_FR_focus.f4966dd51902ffa959b8fcde053a531b.svg";
export { ForwardRef as ReactComponent };